import React, { Component } from 'react'
import TextField, {
  textfieldDefaultOnChange,
} from './../../../components/material/TextField'
import {
  missingRequiredFieldChecker,
  requiredFieldsEvaluator,
} from '../../../utils/formHelper'

import isEmpty from 'lodash/isEmpty'
import { withPropsFromDatabase } from '../../../database/resources/utils'
import { withRouter } from '../../../utils/withRouterCompat'
import FormSection from '../../../components/forms/FormSection'
import FormGrid from '../../../components/forms/FormGrid'
import FormField from '../../../components/forms/FormField'
import FormActions from '../../../components/forms/FormActions'
import AppButton from '../../../components/material/AppButton'
class CorralForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props.initialValues,
    }

    this.textfieldDefaultOnChange = textfieldDefaultOnChange.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    this.requiredFieldsEvaluator = requiredFieldsEvaluator.bind(this)
    this.missingRequiredFieldChecker = missingRequiredFieldChecker.bind(this)
  }

  onCancel() {
    if (this.props.onCancel) {
      this.props.onCancel()
    }
  }

  onEnterPress = (e) => {
    if (
      e.keyCode == 13 &&
      e.shiftKey == false &&
      !(this.props.user.roles[0]?.name === 'Cliente (somente visualização)')
    ) {
      e.preventDefault()
      this.onSubmit()
    }
  }

  onSubmit() {
    let requiredFieldsState = this.requiredFieldsEvaluator()

    let payload = {
      ...this.props.corral,
      nome: this.state.nome,
      fazendaId: this.props.farm.id,
    }
    if (requiredFieldsState !== null) {
      return this.setState(requiredFieldsState)
    }

    if (this.props.onSubmit) {
      this.props.onSubmit(payload)
    }
  }

  render() {
    return (
      <>
        <FormSection title='Identificação' variant='flat'>
          <FormGrid>
            <FormField span={2}>
              <TextField
                id='nome'
                label='Nome do Retiro'
                onChange={this.textfieldDefaultOnChange}
                onKeyDown={this.onEnterPress}
                value={this.state.nome}
                error={!isEmpty(this.state.nome_error)}
                helperText={this.state.nome_error}
                autoFocus
              />
            </FormField>
          </FormGrid>
        </FormSection>

        <FormActions>
          <AppButton variant='tertiary' onClick={this.onCancel}>
            Cancelar
          </AppButton>
          <AppButton
            variant='primary'
            onClick={this.onSubmit}
            disabled={
              this.props.user.roles[0]?.name ===
              'Cliente (somente visualização)'
            }
          >
            Salvar
          </AppButton>
        </FormActions>
      </>
    )
  }
}

const propsFromDatabase = async (props) => ({
  requiredFields: ['nome'],
})

export default withPropsFromDatabase(propsFromDatabase, withRouter(CorralForm))
